import axios from 'axios'
import { installedBaseAPI } from '../InstallBase/api'

export const sparePartsAPI = function (baseURL) {
  this.host = baseURL ? baseURL : 'https://' + window.location.hostname
}

sparePartsAPI.prototype.getURL = function (path) {
  return `${this.host}${path}`
}

// article - product number
// cfid - configuration ID, exists not configurable products
sparePartsAPI.prototype.getParts = function (article, cfid) {
  let url = this.getURL('/ib/api/v1/products/' + encodeURIComponent(article) + '/spare-parts')
  if (cfid != null && cfid.length > 0) {
    url = this.getURL('/ib/api/v1/products-conf/' + encodeURIComponent(cfid) + '/spare-parts')
  }
  console.log('[DEBUG] url:', url)
  return fetch(url, {method: 'GET', credentials: 'include'})
    .then(res => res.json())
}

sparePartsAPI.prototype.getProject = function (projectNumber) {
  const url = this.getURL('/ib/api/v1/project/' + projectNumber)
  return axios.get(url, {withCredentials: true})
}

sparePartsAPI.prototype.getProducts = function (project) {
  const url = this.getURL('/ib/api/v1/projectlist/' + encodeURIComponent(project) + '/products')
  return axios.get(url, {withCredentials: true})
}

sparePartsAPI.prototype.getProductProps = function () {
  const url = this.getURL('/ib/api/v1/settings/product-props')
  return axios.get(url, {withCredentials: true})
}

sparePartsAPI.prototype.createCart = function (customerNo, list) {
  const url = this.getURL(`/ib/api/v1/customers/${customerNo}/spare-parts-cart`)
  return axios.post(url, list, {withCredentials: true})
}

sparePartsAPI.prototype.deleteCart = function (customerNo, cartId) {
  const url = this.getURL(`/ib/api/v1/customers/${customerNo}/spare-parts-cart/${cartId}`)
  return axios.delete(url, {withCredentials: true})
}

sparePartsAPI.prototype.getCart = function (customerNo, cartId) {
  const url = this.getURL(`/ib/api/v1/customers/${customerNo}/spare-parts-cart/${cartId}`)
  return axios.get(url, {withCredentials: true})
}

sparePartsAPI.prototype.replaceCart = function (customerNo, cartId, list) {
  const url = this.getURL(`/ib/api/v1/customers/${customerNo}/spare-parts-cart/${cartId}`)
  return axios.post(url, list, {withCredentials: true})
}

sparePartsAPI.prototype.getProjectList = function () {
  const url = this.getURL('/ib/api/v1/project/list')
  return axios(url, {withCredentials: true})
}